import * as tslib_1 from "tslib";
import { DirectiveForm } from './directive-form';
import { TickDirective } from './tick-directive';
var TickForm = (function (_super) {
    tslib_1.__extends(TickForm, _super);
    function TickForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TickForm.prototype, "tag", {
        get: function () {
            return 'tick';
        },
        enumerable: true,
        configurable: true
    });
    TickForm.prototype.cast = function (item) {
        var timeout = item.header(this.tag);
        if (timeout.isDefined()) {
            return new TickDirective(timeout);
        }
        return undefined;
    };
    TickForm.Form = new TickForm();
    return TickForm;
}(DirectiveForm));
export { TickForm };
DirectiveForm.addGlobal(TickForm.Form);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGljay1mb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGljay1mb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxPQUFPLEVBQUMsYUFBYSxFQUFDLE1BQU0sa0JBQWtCLENBQUM7QUFDL0MsT0FBTyxFQUFDLGFBQWEsRUFBQyxNQUFNLGtCQUFrQixDQUFDO0FBRy9DO0lBQThCLG9DQUE0QjtJQUExRDs7SUFjQSxDQUFDO0lBYkMsc0JBQUkseUJBQUc7YUFBUDtZQUNFLE1BQU0sQ0FBQyxNQUFNLENBQUM7UUFDaEIsQ0FBQzs7O09BQUE7SUFFRCx1QkFBSSxHQUFKLFVBQUssSUFBVTtRQUNiLElBQU0sT0FBTyxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3RDLEVBQUUsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxTQUFTLEVBQUUsQ0FBQyxDQUFDLENBQUM7WUFDeEIsTUFBTSxDQUFDLElBQUksYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ3BDLENBQUM7UUFDRCxNQUFNLENBQUMsU0FBUyxDQUFDO0lBQ25CLENBQUM7SUFFZSxhQUFJLEdBQUcsSUFBSSxRQUFRLEVBQUUsQ0FBQztJQUN4QyxlQUFDO0NBQUEsQUFkRCxDQUE4QixhQUFhLEdBYzFDO1NBZFksUUFBUTtBQWVyQixhQUFhLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyJ9